import FilterBarFunctional from 'components/Pages/PressReleases/FilterBarFunctional';
import searchEntityTypes from 'constants/searchEntityTypes';

const ArticleFilterBar = ({ fields, rendering }) => {
  const filterMappings = fields.filterMappings.value;

  return (
    <FilterBarFunctional
      e2eID={rendering.uid}
      formattedMapping={filterMappings}
      initialTake={20}
      entityTypes={searchEntityTypes.ARTICLE_TYPE}
    />
  );
};

export default ArticleFilterBar;
